import { LegalLayout, Section } from "@/pages/legal/LegalLayout";
import { COMPANY } from "@/lib/site-data";

const Disclosures = () => {
  return (
    <LegalLayout
      testid="page-disclosures"
      title="Disclosures & Disclaimers"
      updated="December 2025"
      lead="Important information about the nature of our services, the limits of the content published on dreamaxis.net, and how to read case studies, forward-looking statements and sustainability claims."
    >
      <Section number="01" title="Corporate identification">
        <p>
          <strong>{COMPANY.legalName}</strong>, trading as <em>{COMPANY.tradeName}</em>,
          is a limited-liability company incorporated under the laws of the
          Republic of Poland, with its registered office at{" "}
          {COMPANY.hqAddress}, NIP / REGON{" "}
          <span className="font-mono">{COMPANY.regon}</span>. The company is
          entered in the Register of Entrepreneurs of the National Court
          Register (KRS) kept by the competent District Court in Warsaw.
        </p>
      </Section>

      <Section number="02" title="Nature of information published on the website">
        <p>
          The content of {COMPANY.domain}, including service descriptions,
          case studies, statistics and industry commentary, is provided for
          general information purposes only. It does not constitute an offer
          within the meaning of Article 66 of the Polish Civil Code, nor a
          recommendation or solicitation to engage in any particular
          commercial, financial or investment activity.
        </p>
      </Section>

      <Section number="03" title="Not investment or legal advice">
        <p>
          Nothing published on {COMPANY.domain} constitutes:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>investment advice within the meaning of the Polish Act of 29 July 2005 on trading in financial instruments;</li>
          <li>legal advice within the meaning of the Polish Act of 6 July 1982 on legal advisers, or of 26 May 1982 on advocates;</li>
          <li>tax, actuarial or accounting advice.</li>
        </ul>
        <p>
          Where such advice is required, please consult a qualified
          professional. {COMPANY.legalName} is not authorised or supervised as
          an investment firm, credit institution, payment institution, e-money
          institution or crowdfunding provider by the Polish Financial
          Supervision Authority (KNF) or any other competent regulator.
        </p>
      </Section>

      <Section number="04" title="Case studies & performance information">
        <p>
          Case studies published on {COMPANY.domain} describe engagements we
          have led or contributed to. Client identities are anonymised or
          referenced only with prior written consent. Figures, metrics and
          outcomes are indicative and refer to the specific circumstances of
          the engagement described. They do not constitute a promise, forecast
          or guarantee of comparable results in any other engagement, market
          or period.
        </p>
      </Section>

      <Section number="05" title="Forward-looking statements">
        <p>
          Some content — including our sector commentary, projected
          programme benefits or roadmap targets — may contain forward-looking
          statements. Such statements involve known and unknown risks and
          uncertainties. Actual outcomes may differ materially from those
          expressed or implied. We undertake no obligation to publicly update
          forward-looking statements once published.
        </p>
      </Section>

      <Section number="06" title="Sustainability & ESG claims">
        <p>
          Where we describe sustainability outcomes (for example, reductions
          in non-revenue water, water-reuse targets or ESG-reporting
          improvements), the figures relate to the specific programme, client,
          period and measurement methodology referenced. They are not
          aggregated corporate ESG disclosures of{" "}
          {COMPANY.legalName} itself and should not be relied upon as such.
        </p>
        <p>
          We align our advisory practice with the EU Corporate Sustainability
          Reporting Directive (CSRD) and GRI standards, but each Client
          remains responsible for the accuracy and audit of its own reported
          data.
        </p>
      </Section>

      <Section number="07" title="Third-party links & content">
        <p>
          {COMPANY.domain} may contain links to third-party websites or
          reference third-party trademarks and content. Such references are
          provided for convenience only. We do not endorse and are not
          responsible for the content, availability, accuracy or privacy
          practices of any third-party resource.
        </p>
      </Section>

      <Section number="08" title="Sanctions, AML & know-your-client">
        <p>
          We conduct client due-diligence in line with the Polish Act of 1
          March 2018 on counteracting money laundering and terrorist financing
          (AML/CFT), and with applicable EU and UN sanctions regimes. We
          reserve the right to decline or discontinue an engagement where such
          due-diligence obligations cannot reasonably be satisfied.
        </p>
      </Section>

      <Section number="09" title="Reliance">
        <p>
          Persons who choose to act on the basis of information published on{" "}
          {COMPANY.domain} do so at their own risk. To the maximum extent
          permitted by Polish law, {COMPANY.legalName}, its directors,
          employees and contractors exclude liability for loss or damage
          arising from any such reliance.
        </p>
      </Section>

      <Section number="10" title="Contact">
        <p>
          If you have questions about any statement, metric or case study
          published on this website, please write to{" "}
          <a
            href={`mailto:${COMPANY.email}`}
            className="text-emerald-800 underline underline-offset-2"
          >
            {COMPANY.email}
          </a>{" "}
          — we will respond as quickly as reasonably possible.
        </p>
      </Section>
    </LegalLayout>
  );
};

export default Disclosures;
